import View from '../../View'
import $ from 'jquery'
import {connect} from '../../redux/utils'
import {bindActionCreators} from 'redux'
import DropdownDialogWithPointerWrapper from '../../components/DropdownDialogWithPointerWrapper'
import AddonsMenu from './AddonsMenu'
import {isAddonsMenuShown, isQbiAvailable, isShowApIntegrationAction} from './selectors'
import {closeAddonsMenu, toggleAddonsMenu} from './actions'
import AddonCard from './AddonCard'
import messageResource from '../../messageResource'
import {canSwitchToQBI} from '../../loggedInUser/selectors'
import {AddonsCardsModels, AddonsMenuActionUrls, ManageLicensesUrl} from './constants'
import Button from '../../components/Button'
import MobileAppButtons from './MobileAppButtons'
import {isLicenseFree, isOtherProductLicenseExpired, isOtherProductLicenseViolated, loggedInUserCanManageLicenses} from '../../activeLicenseInfo/selectors'
import {isOlVersion, PRODUCT_SWITCHER_URL} from '../../constants'

class AddonsMenuContainer extends View {
    constructor({
        toggleAddonsMenu = () => {},
        closeAddonsMenu = () => {},
    } = {}) {
        super()

        this.actions = {
            toggleAddonsMenu,
            closeAddonsMenu,
        }

        this.state = {
            shown: false,

            canManageLicenses: false,
            isShowApIntegrationAction: false,
            isApExpired: false,
            isApViolated: false,
            qbiAvailable: false,
            canSwitchToQBI: false,
            isLicenseFree: false,

            assistantLinkOpened: window.sessionStorage.getItem(
                AddonsCardsModels.ASSISTANT.linkOpenedSessionStorageKey
            )
        }

        this.onStatePropertyChanged('shown', shown => {
            if (shown) {
                this.addonsMenuDialog.showAt($('.popup_menu_button_addons'))
                this.mobileCard.setState({ isNew: isOlVersion })
                this.assistantCard.setState({ isNew: true })
            } else {
                this.addonsMenuDialog.hide(true)
            }
        })

        this.onStatePropertyChanged('isLicenseFree', (isLicenseFree) => {
            this.zapierCard.setState({actionNotAvailable: isLicenseFree})
            this.apiCard.setState({actionNotAvailable: isLicenseFree})
            this.qbiCard.setState({actionNotAvailable: isLicenseFree})
        })

        this.onAnyStatePropertyChanged(['canManageLicenses', 'isLicenseFree'], () => {
            this.addonsMenu.setState({
                showUpgradeSection: this.state.isLicenseFree && this.state.canManageLicenses,
            })
        })

        this.onAnyStatePropertyChanged([
            'qbiAvailable',
            'canSwitchToQBI',
        ], () => {
            this.qbiCard.setState({showActionButton: this.state.qbiAvailable && this.state.canSwitchToQBI})
        })

        this.onStatePropertyChanged('isShowApIntegrationAction', isShowApIntegrationAction =>
            this.apIntegrationCard.setState({
                showActionButton: isShowApIntegrationAction,
            })
        )

        this.onAnyStatePropertyChanged(['isApExpired', 'isApViolated'], () => {
            const showWarning = this.state.isApExpired || this.state.isApViolated

            this.apIntegrationCard.setState({
                showWarning,
                isExpired: this.state.isApExpired,
            })
            this.$alertIcon.toggle(showWarning)
            this.$pulseIcon.toggle(!showWarning && isOlVersion)
        })

        this.onStatePropertyChanged('assistantLinkOpened', () => {
            const showWarning = this.state.isApExpired || this.state.isApViolated

            this.$pulseIcon.toggle(!showWarning && !this.state.assistantLinkOpened && isOlVersion)
        })
    }

    afterRender() {
        $('#popup_menu_button_addons')
            .mousedown(e => e.stopPropagation())
            .click(() => this.actions.toggleAddonsMenu())

        this.$alertIcon = $('.topMenuButton.addons .alertIcon')
        this.$pulseIcon = $('.topMenuButton.addons .pulseIcon')

        const openIntegrationPopup = () => {
            this.addonsMenuDialog.hide()
            window.openAtIntegrationPopup()
        }
        this.apIntegrationCard = new AddonCard({
            ...AddonsCardsModels.AP_INTEGRATION,
            actionNotAvailable: !isOlVersion,
            actionButtonTextKey: PRODUCT_SWITCHER_URL
                                 ? 'menu.addons.item.actiplans.switch_button'
                                 : 'menu.addons.item.actiplans.enable_button',
            onActionButtonClick: () => {
                if (PRODUCT_SWITCHER_URL) {
                    window.location.href = window.unescapeHtmlSymbols(PRODUCT_SWITCHER_URL)
                } else {
                    openIntegrationPopup()
                }
            },
            onDetailsButtonClick: openIntegrationPopup,
            notAvailableButtonTextKey: 'menu.addons.item.actiplans.not_available_button',
            onLinkClickCallback: () => this.addonsMenuDialog.hide(),
        })

        this.qbiCard = new AddonCard({
            ...AddonsCardsModels.QBI,
            onActionButtonClick: () => {
                if (this.state.qbiAvailable && this.state.canSwitchToQBI) this.openUrl(AddonsMenuActionUrls.QBI_ACTION_URL)
            },
            onLinkClickCallback: () => this.addonsMenuDialog.hide(),
        })

        this.zapierCard = new AddonCard({
            ...AddonsCardsModels.ZAPIER,
            onActionButtonClick: () => {
                if (!this.state.isLicenseFree) this.openUrl(AddonsMenuActionUrls.ZAPIER_ACTION_URL)
            },
            onLinkClickCallback: () => this.addonsMenuDialog.hide(),
        })

        this.apiCard = new AddonCard({
            ...AddonsCardsModels.API,
            onActionButtonClick: () => {
                if (!this.state.isLicenseFree) this.openUrl(AddonsMenuActionUrls.API_ACTION_URL)
            },
            onLinkClickCallback: () => this.addonsMenuDialog.hide(),
        })

        this.assistantCard = new AddonCard({
            ...AddonsCardsModels.ASSISTANT,
            additionalClass: 'assistantCard',
            customButtonComponent: new Button({
                additionalClass: 'assistantButton',
                label: messageResource.getMessage(AddonsCardsModels.ASSISTANT.actionButtonTextKey),
                onClickCb: () => {
                    try {
                        window.sessionStorage.setItem(AddonsCardsModels.ASSISTANT.linkOpenedSessionStorageKey, true);
                        this.setState({ assistantLinkOpened: true })
                    } catch (e) {}
                    finally {
                        this.openUrl(AddonsMenuActionUrls.ASSISTANT_ACTION_URL)
                    }
                }
            }),
            onLinkClickCallback: () => this.addonsMenuDialog.hide(),
        })

        this.mobileCard = new AddonCard({
            ...AddonsCardsModels.MOBILE,
            additionalIconClass: 'atMobileAppIcon',
            customButtonComponent: new MobileAppButtons({
                onIosButtonClick: () => this.openUrl(AddonsMenuActionUrls.AT_MOBILE_IOS_ACTION_URL),
                onAndroidButtonClick: () => this.openUrl(AddonsMenuActionUrls.AT_MOBILE_ANDROID_ACTION_URL)
            }),
            onLinkClickCallback: () => this.addonsMenuDialog.hide(),
        })

        this.addonsMenu = new AddonsMenu({
            additionalClass: 'atAddonsMenu',
            onUpgradeButtonClick: () => this.openUrl(ManageLicensesUrl),
            integrationComponents: [this.apIntegrationCard, this.qbiCard, this.zapierCard, this.apiCard],
            addonsComponents: [this.assistantCard],
            mobileComponents: [this.mobileCard]
        })
        this.addonsMenuDialog = new DropdownDialogWithPointerWrapper({
            dialog: this.addonsMenu,
            additionalClass: 'addonsMenuDropdownDialog',
            showAnimationClass: 'popup_menu_slide_down',
            hideAnimationClass: 'popup_menu_slide_up',
            onHide: this.actions.closeAddonsMenu,
            pointerLeftOffset: '-10px',
            dialogOffsets: {
                left: -80,
                top: 8
            }
        }).init($('body'))

        this.renderInitialState()
    }

    openUrl(url) {
        this.addonsMenuDialog.hide()
        window.open(url)
    }
}

export default connect(
    (state) => ({
        shown: isAddonsMenuShown(state),
        canManageLicenses: loggedInUserCanManageLicenses(state),
        qbiAvailable: isQbiAvailable(state),
        canSwitchToQBI: canSwitchToQBI(state),
        isLicenseFree: isLicenseFree(state),
        isShowApIntegrationAction: isShowApIntegrationAction(state),
        isApExpired: isOtherProductLicenseExpired(state),
        isApViolated: isOtherProductLicenseViolated(state),
    }),
    (dispatch) => ({
        toggleAddonsMenu: bindActionCreators(toggleAddonsMenu, dispatch),
        closeAddonsMenu: bindActionCreators(closeAddonsMenu, dispatch),
    })
)(AddonsMenuContainer)



// WEBPACK FOOTER //
// ./web/js/support/addons/AddonsMenuContainer.js